// extracted by mini-css-extract-plugin
export default {"settingsPage":"SettingsPage_settingsPage__6gL2v","main":"SettingsPage_main__TRK2W"};